
export const otpSendType = {
  email: 'We’ve sent a code to your registered Email address',
  sms: 'We’ve sent a code to your registered Mobile number',
  both: 'We’ve sent a code to your registered Mobile number and Email address'
}
